'use client';

import React from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from '@/util/cn';
import { useOTSTranslation } from '@/i18n/useOTSTranslation';

import { ISpinnerProps } from './types';

export const Spinner = ({ color }: ISpinnerProps) => {
  const { t } = useOTSTranslation('common');
  return (
    <Loader2
      className={cn('h-[100px] w-[100px] animate-spin', !color && 'text-primary')}
      style={color ? { color } : undefined}
      aria-label={t('common.loading')}
    />
  );
};
